import { render, staticRenderFns } from "./ObjSelect.vue?vue&type=template&id=c0138ff6&scoped=true"
import script from "./ObjSelect.vue?vue&type=script&lang=js"
export * from "./ObjSelect.vue?vue&type=script&lang=js"
import style0 from "./ObjSelect.vue?vue&type=style&index=0&id=c0138ff6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0138ff6",
  null
  
)

export default component.exports